import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { myAxios, MyFormData } from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
//--------------------------------------------------------------------------------------------
export default function CreateYardModal({ closeIt, onDone }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [name, setName] = useState("");
    const handleSubmit = async() => {
        if(!name.trim()){
            window.alert("Please enter a yard name.");
            return;
        }
        const formData = new MyFormData();
        formData.append("name", name);
        setShowLoader(true);
        const res = await myAxios("inventory/createYard.php", formData);
        setShowLoader(false);
        if(!res) return;
        onDone();
        closeIt();
    };
    return <Modal title = "Create Yard" closeIt = {closeIt} width = "36rem" handleFormSubmit = {handleSubmit} actionKey = "Create Yard" formFormat = "">
        <div className = "inventoryModalBody">
            <label className = "font-weight-bold" htmlFor = "inventoryYardName">Yard Name</label>
            <input id = "inventoryYardName" className = "form-control" value = {name} onChange = {e => setName(e.currentTarget.value)} placeholder = "Example: Main Yard" autoFocus/>
        </div>
    </Modal>;
}
